<style lang="scss">
  @import '../resources/scss/digital_platform.scss';
</style>

<script lang="ts">
  import type PlatformSection from '../api/rest/directus-cms/digitalgrow/models/PlatformSection'

  export let section: PlatformSection
</script>

{#if section}
  <section id="digital-grow-profile">
    <div class="container-xxl bg-white py-section">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h1 class="text-primary">{section.formation_profiles_title}</h1>
          </div>
        </div>
        <div class="row py-4">
          <div class="col-12">
            <div class="d-flex">
              <div class="col-12 text-white profiles-container">
                {#each section.formation_profiles as profile, index}
                  <div
                    class="col-12 profile-item"
                    style="background-color: {profile.color};"
                  >
                    <span class="h3 mb-0">{index + 1}</span>
                    <div class="profile-description mb-0 h4">
                      {@html profile.description}
                    </div>
                    {#if profile.value}
                      <span class="h2 me-1 align-self-center mb-0">{profile.value}</span
                      ><span class="h4 align-self-center mb-0">%</span>
                    {/if}
                  </div>
                {/each}
              </div>
            </div>
          </div>
        </div>
        <div class="row pt-2 mt-5">
          <div class="col-12 col-lg-6 align-self-center">
            <h2 class="text-primary mt-4 mt-lg-0">
              {@html section.users_text}
            </h2>
          </div>
          <div
            class="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-start align-items-center"
          >
            <img
              class="img-fluid"
              src={section.users_image?.fullUrl}
              alt={section.users_title}
            />
          </div>
        </div>
      </div>
    </div>
  </section>
{/if}
